import { ref } from 'vue'

export function useCalendar() {
  
  let calendar = ref([])
  let targetDate = ref(null)

  const mountMonth = (t) => {
    const date = new Date(t)
    targetDate.value = t

    let firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1)
    let daysInMonth = new Date(
      date.getFullYear(),
      date.getMonth() + 1,
      0
    ).getDate()

    // Cria um array com todos os dias do mês
    let daysArray = []
    for (let i = 1; i <= daysInMonth; i++) {
      daysArray.push(new Date(date.getFullYear(), date.getMonth(), i))
    }

    // Se o primeiro dia do mês não for domingo, inclui os dias anteriores
    let firstDayWeekday = firstDayOfMonth.getDay()
    if (firstDayWeekday !== 0) {
      // 0 representa domingo
      for (let i = firstDayWeekday; i > 0; i--) {
        let previousDay = new Date(firstDayOfMonth)
        previousDay.setDate(firstDayOfMonth.getDate() - i)
        daysArray.unshift(previousDay)
      }
    }

    // Inclui os dias do próximo mês até completar a semana
    let lastDayOfWeek = daysArray[daysArray.length - 1].getDay()
    if (lastDayOfWeek !== 6) {
      // 6 representa sábado
      let nextDay = new Date(daysArray[daysArray.length - 1])
      for (let i = 1; i <= 6 - lastDayOfWeek; i++) {
        nextDay.setDate(nextDay.getDate() + 1)
        daysArray.push(new Date(nextDay))
      }
    }
    calendar.value = daysArray
  }

  const getFirstDayOfMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth(), 1)
  }

  const nextMonth = () => {
    const date = targetDate.value
    let first = new Date(date.getFullYear(), date.getMonth(), 1)
    targetDate.value = new Date(first.getFullYear(), first.getMonth() + 1, 1)
    mountMonth(targetDate.value)
  }

  const prevMonth = () => {
    const date = targetDate.value
    let last = new Date(date.getFullYear(), date.getMonth(), 1)
    targetDate.value = new Date(last.getFullYear(), last.getMonth() - 1, 1)
    mountMonth(targetDate.value)
  }

  return {
    mountMonth,
    getFirstDayOfMonth,
    nextMonth,
    prevMonth,
    calendar,
    targetDate
  }
}
